/**
 * Utility to suppress benign ResizeObserver errors
 * These errors are common with UI libraries and don't affect functionality
 */

// Store the original console.error
const originalError = console.error;

// Override console.error to filter ResizeObserver errors
console.error = (...args) => {
  const errorMessage = args[0]?.toString() || '';
  
  // Check if it's a ResizeObserver error
  if (
    errorMessage.includes('ResizeObserver loop limit exceeded') ||
    errorMessage.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // Silently ignore ResizeObserver errors
    return;
  }
  
  // For all other errors, use the original console.error
  originalError.apply(console, args);
};

// Add global error handler
window.addEventListener('error', (event) => {
  const message = event.message || event.error?.message || '';
  
  if (
    message.includes('ResizeObserver loop limit exceeded') ||
    message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

// Add unhandled rejection handler
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || '';
  
  if (
    message.includes('ResizeObserver loop limit exceeded') ||
    message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.preventDefault();
  }
});

export default {};
